/* eslint-disable prefer-destructuring */
import { withContextualizedTracking, track, useTracking } from 'lib/analytics'
import { InfoButton } from 'components/buttons'
import { createBirthdayWishlistPath } from 'lib/urls'

export interface PostConfettiBannerProps {
  content: string
  title: string
}

function extractButtonAndParagraph(htmlString: string) {
  const pattern = /<p>(.*?)<button[^>]*>.*?<\/button><\/p>/i
  const buttonDataPattern = /<button[^>]*name="([^"]*)"[^>]*>(.*?)<\/button>/i

  const match = htmlString.match(pattern)

  let buttonString = ''
  let htmlContent = htmlString
  let buttonText = ''
  let buttonName = ''

  if (match) {
    buttonString = match[0]
    htmlContent = htmlString.replace(pattern, '')
  }

  if (buttonString) {
    const buttonDataMatch = buttonString.match(buttonDataPattern)
    if (buttonDataMatch) {
      buttonText = buttonDataMatch[2]
      buttonName = buttonDataMatch[1]
    }
  }

  return { htmlContent, buttonString, buttonText, buttonName }
}

function PostConfettiBanner({ content, title }: PostConfettiBannerProps) {
  const tracker = useTracking()

  const currentUser =
    typeof window !== 'undefined' ? window.currentUser : undefined

  if (!currentUser) {
    return null
  }

  const { htmlContent, buttonString, buttonText, buttonName } =
    extractButtonAndParagraph(content)
  const handleCreateNewRegistryClicked = () => {
    tracker.trackEvent({
      event: track.listTypeClicked,
      eventLocation: track.EventLocation.GUIDES,
      listType: track.ListType.BIRTHDAY,
      registryId: currentUser?.registryId,
      registryOwnerId: currentUser?.id,
    })
    window.location.href = createBirthdayWishlistPath
  }

  const birthdayCTA = (
    <InfoButton pill onClick={handleCreateNewRegistryClicked}>
      {buttonText}
    </InfoButton>
  )

  return (
    <div className="edge-to-edge confetti-wrapper">
      <div className="confetti">
        <h3 className="mtn mbl text-center">{title}</h3>
        <div className="text-center mbl">
          <span dangerouslySetInnerHTML={{ __html: htmlContent }} />
          {buttonName === 'birthday-cta' ? (
            birthdayCTA
          ) : (
            <span dangerouslySetInnerHTML={{ __html: buttonString }} />
          )}
        </div>
      </div>
    </div>
  )
}

export default withContextualizedTracking({
  eventLocation: track.EventLocation.GUIDE,
})(PostConfettiBanner)
